import React from 'react';
import { motion } from 'framer-motion';
import { Loader } from 'lucide-react';

/**
 * Lightweight inline spinner for non-blocking loading states.
 * Use inside buttons, cards, or inline sections — NOT for full-page loading.
 * For full-page loading, use <LoadingSpinner /> instead.
 */
const InlineSpinner = ({
    message = '',
    size = 'md', // 'sm' | 'md' | 'lg'
    className = '',
}) => {
    const sizeMap = {
        sm: { icon: 'w-4 h-4', text: 'text-xs', gap: 'gap-2', pad: 'p-2' },
        md: { icon: 'w-5 h-5', text: 'text-sm', gap: 'gap-3', pad: 'p-4' },
        lg: { icon: 'w-6 h-6', text: 'text-base', gap: 'gap-3', pad: 'p-6' },
    };

    const s = sizeMap[size] || sizeMap.md;

    return (
        <div className={`flex items-center justify-center ${s.gap} ${s.pad} ${className}`}>
            <motion.div
                animate={{ rotate: 360 }}
                transition={{ duration: 1, repeat: Infinity, ease: 'linear' }}
            >
                <Loader className={`${s.icon} text-emerald-400`} />
            </motion.div>
            {message && (
                <span className={`${s.text} text-slate-400 font-mono`}>{message}</span>
            )}
        </div>
    );
};

export default InlineSpinner;
